import React from "react";
import BuyBanner from "./BuyBanner";
import Cart from "./Cart";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class Buy extends React.Component {
  render() {
    return (
      <div>
        <BuyBanner />
        <Cart />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(Buy);



// WEBPACK FOOTER //
// ./src/pages/buy/index.js